import { Entity } from '@shared/entities/entity';
import { JsonObject, JsonProperty } from 'json2typescript';
import { DateConverter } from '@shared/entities/converters/date-converter';

@JsonObject('Ticket')
export class Ticket extends Entity {
  @JsonProperty('caseNumber', String)
  public caseNumber?: string = undefined;
  @JsonProperty('serialNumber', String)
  public serialNumber?: string = undefined;
  @JsonProperty('createdDate', DateConverter)
  public createdDate?: Date = undefined;
  @JsonProperty('closedDate', DateConverter)
  public closedDate?: Date = undefined;
  @JsonProperty('isClosed', Boolean)
  public isClosed?: boolean = false;
  @JsonProperty('subject', String)
  public subject?: string = undefined;
  @JsonProperty('status', String)
  public status?: string = undefined;
  @JsonProperty('resolution', String)
  public resolution?: string = undefined;
  @JsonProperty('errorMessage', String)
  public errorMessage?: string = undefined;

  /* Ticket creation */
  @JsonProperty('firstName', String)
  public firstName?: string = undefined;
  @JsonProperty('lastName', String)
  public lastName?: string = undefined;
  @JsonProperty('email', String)
  public email?: string = undefined;
  @JsonProperty('phone', String)
  public phone?: string = undefined;
  @JsonProperty('description', String)
  public description?: string = undefined;
  @JsonProperty('assetId', String)
  public assetId?: string = undefined;
  @JsonProperty('accountId', String)
  public accountId?: string = undefined;
  @JsonProperty('contactId', String)
  public contactId?: string = undefined;
  @JsonProperty('attachmentBody', String)
  public attachmentBody?: string = undefined;
  @JsonProperty('attachmentFileName', String)
  public attachmentFileName?: string = undefined;

  @JsonProperty('containsAttachment', Boolean)
  public containsAttachment?: boolean = false;
}
